import React from "react";
import { Trash2, User } from "lucide-react";
import { Field, SelectField, inputCls, cardCls } from "./FormBits";

const GENDERS = ["Male", "Female", "Prefer not to say"];

function KitSizes({ p, i, sizes, setP }) {
  return (
    <div className="mt-5">
      <div className="text-xs font-semibold uppercase tracking-widest text-[#008057] mb-3">Training Kit Sizes</div>
      <div className="grid sm:grid-cols-3 gap-4">
        <SelectField label="T-Shirt size" testid={`select-kit-size-${i}`} value={p.tshirt_size} options={sizes.tshirt} onChange={(v) => setP({ tshirt_size: v })} />
        <SelectField label="Shorts size" testid={`select-shorts-size-${i}`} value={p.shorts_size} options={sizes.shorts} onChange={(v) => setP({ shorts_size: v })} />
        <SelectField label="Socks size" testid={`select-socks-size-${i}`} value={p.socks_size} options={sizes.socks} onChange={(v) => setP({ socks_size: v })} />
      </div>
    </div>
  );
}

function MedicalInfo({ p, setP }) {
  return (
    <div className="mt-5">
      <div className="text-xs font-semibold uppercase tracking-widest text-[#008057] mb-2">Medical / Allergies</div>
      <label className="flex items-center gap-2 text-sm font-semibold text-[#03281B]">
        <input type="checkbox" className="accent-[#008057] w-4 h-4" checked={p.medical_none} onChange={(e) => setP({ medical_none: e.target.checked, medical_details: e.target.checked ? "" : p.medical_details })} />
        None
      </label>
      {!p.medical_none && (
        <textarea className={`${inputCls} mt-2`} rows={2} placeholder="Injuries, medical considerations, or allergies" value={p.medical_details} onChange={(e) => setP({ medical_details: e.target.value })} />
      )}
    </div>
  );
}

export function ParticipantCard({ p, i, sizes, canRemove, onChange, onRemove }) {
  const setP = (patch) => onChange({ ...p, ...patch });
  return (
    <div className={cardCls}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2 font-display font-bold text-lg text-[#03281B]"><User size={20} className="text-[#008057]" /> Participant {i + 1}</div>
        {canRemove && (
          <button data-testid={`remove-participant-${i}`} onClick={onRemove} className="text-red-500 hover:text-red-700 flex items-center gap-1 text-sm font-semibold"><Trash2 size={16} /> Remove</button>
        )}
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="First name" required><input data-testid={`input-participant-name-${i}`} className={inputCls} value={p.first_name} onChange={(e) => setP({ first_name: e.target.value })} /></Field>
        <Field label="Last name" required><input data-testid={`input-participant-lastname-${i}`} className={inputCls} value={p.last_name} onChange={(e) => setP({ last_name: e.target.value })} /></Field>
        <Field label="Date of birth" required><input data-testid={`input-participant-dob-${i}`} type="date" className={inputCls} value={p.dob} onChange={(e) => setP({ dob: e.target.value })} /></Field>
        <SelectField label="Gender" testid={`select-gender-${i}`} value={p.gender} options={GENDERS} onChange={(v) => setP({ gender: v })} />
      </div>
      <KitSizes p={p} i={i} sizes={sizes} setP={setP} />
      <MedicalInfo p={p} setP={setP} />
    </div>
  );
}
